import {usePermissions} from './usePermissions'

export const useCustomerRewardsPromo = () => {
  const {data, isLoading} = usePermissions()

  const {rewardsPromoEligible, showRewardPromoBanner} = data || {}

  return {rewardsPromoEligible, showRewardPromoBanner, isLoading}
}
